//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/DisplayableObject.js";
let d=[[],[[[],"DoUpdate",{},0,0],[[],"EvaluateRulesAndUpdate",{},0,0],[["tableCell","text"],"EditCellText",{},2,0],[["rowsOrColumns","resizeValue"],"ResizeRowsCols",{},2,0],[["rows"],"LockUnlockRows",{},1,0],[["selectedRows","insertRowsInTabularNote"],"InsertRows",{},2,0],[["selectedColumns","insertColumnsInTabularNote"],"InsertColumns",{},2,0],[[],"InsertHeaderRow",{},0,0],[["row"],"IsRowLocked",{R_:{result:''}},1,0],[["filePath"],"SaveAsTemplate",{},1,0],[["nRows"],"GetRows",{R_:{rows:"Annotations.TableRow[]"}},0,0],[["nColumns"],"GetColumns",{R_:{columns:"Annotations.TableColumn[]"}},0,0],[["nHeaderRows"],"GetHeaderRows",{R_:{headerRows:"Annotations.TableRow[]"}},0,0],[["nSections"],"GetSections",{R_:{sections:"Annotations.TableSection[]"}},0,0]],[]];
SPLM.Annotations.Table = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.Table";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.Table.InsertRowsType = Object.freeze({
    "Above" : "Above", "Below" : "Below"});

SPLM.Annotations.Table.InsertColumnsType = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

export default SPLM;